import { Component } from 'react';
import classNames from 'clsx';
import PropTypes from 'prop-types';
import interpolateComponents from 'interpolate-components';
import { LANDING_SUGGEST_SEARCH_V2 } from '../../constants/localizations/landing';
import cssVariables from '../../styles/variables';
import SearchBar from '../search/Searchbar';
import searchCss from '../search/search.module.scss';
import commonCss from '../../styles/common.module.scss';
import {
  ERROR_TEXT,
  ERROR_TITLE,
} from '/src/common/constants/localizations/error';
import { LocationAndLocalizationContext } from '../../providers/LocationAndLocalizationProvider';
import css from './errorPage.module.scss';
import ErrorPageUnderlineLink from './ErrorPageUnderlineLink';

class ErrorPage extends Component {
  static propTypes = {
    shouldHideSearch: PropTypes.bool,
    localizations: PropTypes.object,
    customErrorTitleKey: PropTypes.string,
    customErrorSubtitleKey: PropTypes.string,
  };

  // this component is NOT always wrapped with a context provider
  static contextType = LocationAndLocalizationContext;

  render() {
    const {
      shouldHideSearch,
      localizations,
      customErrorTitleKey,
      customErrorSubtitleKey,
    } = this.props;
    const { getLocalizedText } = this.context || {};
    const searchIconProps = {
      width: '26px',
      height: '26px',
      fill: cssVariables['--secondary-color-5'],
    };

    const titleTextKey = customErrorTitleKey || ERROR_TITLE;
    const subtitleTextKey = customErrorSubtitleKey || ERROR_TEXT;

    return (
      <div className={commonCss.contentContainer}>
        {!shouldHideSearch && (
          <div
            id="searchBarContainer"
            data-testid="searchBarContainer"
            className={classNames(
              css.searchBarContainer,
              searchCss.searchBarContainer,
            )}
          >
            <SearchBar
              iconContainerClassName={searchCss.searchIconContainer}
              placeholder={
                getLocalizedText?.(LANDING_SUGGEST_SEARCH_V2) ||
                localizations?.[LANDING_SUGGEST_SEARCH_V2]
              }
              iconProps={searchIconProps}
            />
          </div>
        )}
        <div
          id="errorTextAndVideoContainer"
          data-testid="errorTextAndVideoContainer"
          className={classNames(css.errorTextAndVideoContainer, {
            [css.withoutSearch]: shouldHideSearch,
          })}
        >
          <div className={css.errorVideoImage}>
            <img
              src="/assets/img/error/signOff.png"
              className={css.image1}
              role="presentation"
            />
            <img
              src="/assets/img/error/signOn.png"
              className={css.image2}
              role="presentation"
            />
            <img
              src="/assets/img/error/textLight.png"
              className={css.image3}
              role="presentation"
            />
          </div>

          <div
            id="errorTextContainer"
            data-testid="errorTextContainer"
            className={css.errorTextContainer}
          >
            <h1 data-testid="errorTextTitle" className={css.errorTextTitle}>
              {getLocalizedText?.(titleTextKey) ||
                localizations?.[titleTextKey]}
            </h1>
            <h3 data-testid="errorTextSubtitle" className={css.errorText}>
              {interpolateComponents({
                mixedString:
                  getLocalizedText?.(subtitleTextKey) ||
                  localizations?.[subtitleTextKey],
                components: {
                  a: <ErrorPageUnderlineLink />,
                },
              })}
            </h3>
          </div>
        </div>
      </div>
    );
  }
}

export default ErrorPage;
